<div fxLayout="row" fxLayoutAlign="center center">
  <div fxFlex="90" fxFlex.sm="75" fxFlex.md="60" fxFlex.lg="45" fxFlex.xl="30">
    <h1 class="heading1">Test Component.</h1>
    <mat-divider></mat-divider>
    <button id="btnGenerateChunkLoadError" type="button" mat-raised-button class='btn-round ls-2 lh-50 mt-10' (click)="generateChunkLoadError()">Generate Chunk Load Error</button>
    <button id="btnSimpleError" type="button" mat-raised-button class='btn-round ls-2 lh-50 ml-10 mt-10' (click)="generateError()">Generate Error</button>
  </div>
</div>
